<template>
  <div class="chart-container">
    <div v-if="size !== 'mini'" class="chart-legend-container" style="height: 50px;">
      <label>
        <span class="chart-mark chart-mark-out-mer"></span><span class="chart-legend-name">中央誤差率の外側</span>
      </label>
      <label>
        <span class="chart-mark chart-mark-around-mer"></span><span class="chart-legend-name">中央誤差率の周囲</span>
      </label>
      <label>
        <span class="chart-mark chart-mark-in-mer"></span><span class="chart-legend-name">中央誤差率の内側</span>
      </label>
    </div>
    <div class="chart-main-container">
      <chart ref="chart" chartType="bar" chartId="MERCompareChart" :width="size === 'mini' ? 300 : 836"
             :height="size === 'mini' ? 180 : 400"></chart>
    </div>
    <div class="chart-column-container" v-if="merCompareComparison.results.length > 1 && size !== 'mini'">
      <el-radio v-for="(result, index) in merCompareComparison.results" v-model="selectedColumnIndex"
                name="mer-compare-column" :label="index">{{ result.name }}
      </el-radio>
    </div>
  </div>
</template>

<script lang="js">
import ChartCmp from './base.vue'
import FormatUtil from '../../utils/format'
import CommonUtil from '../../utils/common'

export default {
  name: 'MerCompareChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    merCompareComparison: {type: Object, default: () => {}},
    yName: '',
    categoryId: '',
    size: '',
    initialColumnIndex: {type: Number, default: 0}
  },
  data () {
    return {
      selectedColumnIndex: -1,
      selectedMerCompareResult: null
    }
  },
  created () {
    this.selectedColumnIndex = this.initialColumnIndex
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  },
  watch: {
    selectedColumnIndex (newIndex) {
      if (newIndex < 0) return
      this.selectedMerCompareResult = this.merCompareComparison.results[newIndex]
    },
    selectedMerCompareResult (merCompareResult) {
      if (!merCompareResult) return

      const yCount = merCompareResult.value.map(value => value.yCount)
      const order = merCompareResult.value.map(value => value.order)
      const backgroundColors = merCompareResult.value.map(
        value => (value.inMer === 0.5 ? '#ff7d98' : value.inMer === 1.0 ? '#ff305c' : '#86C7F5'))
      const isMini = this.size === 'mini'

      let datasets = []
      datasets.push(
        Object.assign(
          {
            data: yCount,
            type: 'bar',
            yAxisID: 'count',
            fill: false,
            lineTension: 0,
            backgroundColor: backgroundColors
          }
        )
      )

      const chartData = {
        labels: order,
        datasets: datasets
      }

      const options = {
        responsive: isMini,
        title: {
          display: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              id: 'count',
              type: 'linear',
              position: 'left',
              scaleLabel: {
                display: !isMini,
                labelString: '件数',
                fontSize: 16
              },
              ticks: {
                beginAtZero: false,
                major: {},
                minor: {},
                callback: function (value, index, values) {
                  return CommonUtil.isEmpty(value) ? '' : `${FormatUtil.formatNumber(value)}`
                }
              }
            }],
          xAxes: [
            {
              display: !isMini,
              scaleLabel: {
                display: !isMini,
                labelString: '誤差率',
                fontSize: 16
              },
              ticks: {
                beginAtZero: true,
                major: {},
                minor: {},
                showLine: false,
                minRotation: 90,
                maxRotation: 90
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const datasetIndex = tooltipItem.datasetIndex
              let label = data.datasets[datasetIndex].label || ''

              if (CommonUtil.isNotEmpty(label)) {
                label += ': '
              }
              label += FormatUtil.formatNumber(tooltipItem.yLabel)

              return label
            }
          }
        }
      }

      this.$refs.chart.renderChart(chartData, options)
    }
  }
}

</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
  }

  .chart-legend-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .chart-legend-container > label {
    display: flex;
    align-items: center;
  }

  .chart-mark {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .chart-mark-out-mer {
    background-color: #86C7F5;
  }

  .chart-mark-around-mer {
    background-color: #ff7d98;
  }

  .chart-mark-in-mer {
    background-color: #ff305c;
  }

  .chart-legend-name {
    margin-right: 10px;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/mer-compare.vue